import React from 'react';
import Icon, { IconProps } from '../Icon';

const HomeIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 17 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.1861 0.104659L0.201222 6.28651C0.0760399 6.38274 -0.000614473 6.53913 3.71096e-06 6.69702V18.0304C2.94686e-05 18.3001 0.245423 18.5455 0.515157 18.5456H5.92426C6.194 18.5455 6.43939 18.3001 6.43942 18.0304V11.8486H10.5606V18.0304C10.5607 18.3001 10.8061 18.5455 11.0758 18.5456H16.4849C16.7546 18.5455 17 18.3001 17.0001 18.0304V6.69702C17.0001 6.53913 16.924 6.38274 16.7988 6.28651L8.81396 0.104659C8.57929 -0.0420053 8.37717 -0.027581 8.1861 0.104659ZM8.50003 1.15913L15.9697 6.94655V17.5153H11.5909V11.3334C11.5909 11.0637 11.3455 10.8183 11.0758 10.8183H5.92426C5.65453 10.8183 5.40914 11.0637 5.40911 11.3334V17.5153H1.03031V6.94655L8.50003 1.15913Z"
          fill="currentColor"
        />
      </svg>
    </Icon>
  );
};
export default HomeIcon;
